import { Link } from "@mui/material";

const GoodTeammate = () => {
  return (
    <div className="container--blog_post_page_wrapper">
      <section className="container--blog_post">
        <div className="container--post_content">
          <p className="text--post_paragraph">
            Teamwork is such a vital aspect of life that parents and educators
            begin teaching the necessary skills at a very young age through
            games, sports, and group works. Now that you are older, you may have
            the responsibility of creating and leading teams that are expected
            to perform at much higher standards, so you need high-quality
            members.
          </p>
          <p className="text--post_paragraph">
            We’ve put together a shortlist of key characteristics that make a
            great teammate. When building your ideal team, it’s good to first
            check for these characteristics within yourself, and then find
            others that will get the synergy flowing.
          </p>
          <h2 className="header header--page_title_h2_left">Personality</h2>
          <p className="text--post_paragraph">
            It’s very important for team members to be genuinely interested in
            one another. Having a vested interest in your teammates will help
            the entire team to{" "}
            <Link
              href="https://smallbusiness.chron.com/build-positive-relationships-among-team-members-10129.html"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read blog post titled: Build Positive Relationships Among Team Members"
            >
              work together cohesively
            </Link>{" "}
            because you’ve all taken the time to understand each other’s
            strengths, weaknesses, likes, and dislikes. If you find that one
            member of the team is having a hard time adjusting, consider a{" "}
            <Link
              href="https://snacknation.com/blog/virtual-team-building/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read blog post titled: Virtual Team Building"
            >
              team-building exercise
            </Link>
            . There are many that you can do remotely if your team is spread out
            all over the world.
          </p>
          <h2 className="header header--page_title_h2_left">Reliability</h2>
          <p className="text--post_paragraph">
            You want to know that your teammate is going to follow through with
            the responsibilities they are given. This can be a tough quality to
            find if you’re building a team of people that you’ve never worked
            with before, so you may have to have a little faith. Start off by
            assigning small tasks that don’t carry much weight. If everyone
            follows through, you can move on to bigger tasks that carry more
            responsibility.{" "}
            <Link
              href="https://www.teammateme.com/"
              target="_blank"
              rel="noreferrer noopener dofollow"
              aria-label="Find reliable team members through TeammateMe"
            >
              TeammateMe
            </Link>{" "}
            makes it easy for you to build teams with reliable members through
            member profiles and anonymous member reviews.
          </p>
          <h2 className="header header--page_title_h2_left">
            Willing to Listen
          </h2>
          <p className="text--post_paragraph">
            <Link
              href="https://www.verywellmind.com/what-is-active-listening-3024343"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
            >
              Active listening
            </Link>{" "}
            in a team is very important because it helps you intentionally
            process and retain information. It also helps the person that is
            speaking feel as though their words are being truly valued and not
            ignored. Active listening should be used in every group scenario
            from listening to instructions to receiving feedback.
          </p>
          <p>Here are some tips for practicing active listening:</p>

          <ul className="text--post_bullet-alt">
            <li>Ask questions</li>
            <li>Reflect what is said back to the speaker</li>
            <li>Ask the speaker to clarify</li>
            <li>Summarize when they are finished</li>
          </ul>
          <h2 className="header header--page_title_h2_left">
            Willing to Learn
          </h2>
          <p className="text--post_paragraph">
            High-quality teammates should know their strengths and lean into
            them, but they should also work to make themselves even stronger in
            those areas, as well as work on their weaknesses. Teams should
            provide feedback to their members that celebrate success, points out
            areas where growth is possible and offers suggestions for how to
            work better next time. A great team member should receive that
            feedback well and adopt suggested practices into their work.
          </p>
          <p className="text--post_paragraph">
            Finding teammates that you have synergy with is crucial for the
            productivity of the team. You can almost guarantee that you will
            find synergy if you keep an eye out for these characteristics in
            prospective teammates – and you are confident that you’re bringing
            these characteristics to the table, as well.
          </p>
        </div>
        <hr className="hr--form_break" />
      </section>
    </div>
  );
};

export default GoodTeammate;
